export const env_variables = {
  API_URL: "http://localhost:7086",
  SEND_GRID_KEY:
    "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",
  PLAID_CLIENT_ID: "61ba296eed273e001aa8de53",
  PLAID_SECRET_KEY: "4198e3a7ec450a706361857be90ebc",
  FROM_MAIL: "no_reply@atg.money",
};
